<template>
  <div>
    <div class="card__header">
      <p class="card__title">Summary</p>
    </div>
    <div class="card__content">
      <p class="card__subheader">Information</p>
      <div class="card card--xs card--noShadow fill--paper">
        <div class="card__content">
          <div class="grid grid--jcSpaceBetween">
            <p class="text--bold">Start date</p>
            <p>{{ $parent.date }}</p>
          </div>
          <div class="grid grid--jcSpaceBetween">
            <p class="text--bold">Delivery method</p>
            <p>{{ $parent.method | orderTypeToLabel }}</p>
          </div>
        </div>
      </div>
    </div>

    <PopupLoader v-if="$parent.loading || loading"/>
    <template v-else>
      <div class="card__content">
        <h3 class="card__subheader">Basket</h3>
        <div class="accordion accordion--recurring" data-module="collapse">
          <DailySimulation
            v-for="dailySimulation in simulation.daily_simulations"
            :dailySimulation="dailySimulation"
          />
        </div>
        <div class="card card--xs card--noShadow fill--paper mt-1">
          <div class="card__content pr-5">
            <div class="grid grid--jcSpaceBetween text--bold">
              <p>Weekly total</p>
              <p>£{{ (simulation.weekly_simulation.total / 100) | setDecimals }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="card__actions">
        <button type="button" class="button button--md button--grey" v-on:click="prevStep()">Back</button>
        <button type="button" class="button button--md button--secondary" v-on:click="nextStep()" v-if="!$parent.loading">{{ nextLabel }}</button>
      </div>
    </template>
  </div>
</template>

<script>
import DailySimulation from "./DailySimulation.vue";
import PopupLoader from "../icon/popup-loader.vue";

export default {
  data() {
    return {
      price: 0,
      nextLabel: 'Next',
      simulation: null,
      loading: true,
    }
  },

  components: {
    DailySimulation,
    PopupLoader,
  },

  async beforeMount() {
    this.price = 0;

    const cart = this.$parent.cart;
    const formattedCart = [];
    Object.keys(cart).map((day) => (
      Object.keys(cart[day].products)
        .filter((product) => {
          return cart[day].products[product].qty > 0;
        })
        .map((product) => {
          formattedCart.push({
            'product_id': cart[day].products[product].id,
            'quantity': cart[day].products[product].qty,
            'time_slot_id': cart[day].time_slot_id,
          });
        })
    ));

    const simulation = await axios.post('/api/recurring-order/simulate', {
      cart: formattedCart,
      method: this.$parent.method,
      start_at: moment(this.$parent.date, 'DD/MM/YYYY').format('YYYY-MM-DD')
    });

    this.simulation = simulation.data;

    this.loading = false;

    if (this.$root.user.has_payment_method) {
      this.nextLabel = 'Order';
    }
  },

  methods: {
    prevStep(){
      this.$parent.step = 'BASKET';
    },

    nextStep(){
      if(this.$root.user.has_payment_method){
        this.$parent.sendOrder();
      } else {
        this.$parent.step = 'PAYMENT';
      }
    }
  }
}
</script>
